import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../_models/user';
import { UserService } from '../_services/user.service';
import { OfferService } from '../_services/offer.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { Utilities } from '../commons/utilities';
import { MediaService } from '../_services/media.service';
declare var $: any;
import { PaymentMethod } from '../_models/PaymentMethod';

import { combineLatest, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environment';
import { ShippingMeanService } from '../_services/shipping-mean.service';
import { ShippingType } from '../_models/shipping-type';
import { ShippingOfferService } from '../_services/shipping-offer.service';
import { TranslateService } from '@ngx-translate/core';
import { OfferEditDTO } from '../_models/offer-edit-dto';

@Component({
    selector: 'app-offer-view',
    templateUrl: './offer-view.component.html',
    styleUrls: ['./offer-view.component.css'],
    standalone: false
})
export class OfferViewComponent implements OnInit, OnDestroy {
    offer: any;
    user: User;
    offerId: string;
    hasPictures = false;
    mediaList = [];
    paymentMethods: PaymentMethod[];
    myPaymentMethods = [];
    selectedPaymentMethods = [];
    picture: any;
    imageChangedEvent: any = '';
    imageCroppedEvent: ImageCroppedEvent;
    croppedImage: any;
    totalOfImages = 0;
    loading = true;
    formShippingOpened = false;
    shippingTypes: ShippingType[];
    shippingOffers = [];
    shippingOffer: any;
    shippingMeans = [];

    // New shipping options
    availableShippingOptions: any[] = [];
    selectedShippingOptions: number[] = [];

    // Modal state
    showShippingOptionsModal = false;
    modalShippingOptions: any[] = [];
    modalShippingPricings: Map<number, any[]> = new Map();
    modalPricingLoading: Map<number, boolean> = new Map();
    modalLoading = false;
    modalSelectedOptions: number[] = [];

    currentLanguage = 'fr';

    private subscriptions: Subscription[] = [];

    constructor(
        private state: ActivatedRoute,
        private toastrService: ToastrService,
        private offerService: OfferService,
        private shippingOfferService: ShippingOfferService,
        public userService: UserService,
        private shippingMeanService: ShippingMeanService,
        private mediaService: MediaService,
        private translateService: TranslateService
    ) {
        this.user = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
        this.shippingTypes = [];
        this.currentLanguage = translateService.currentLang;
    }

    ngOnInit() {
        this.offerId = this.state.snapshot.paramMap.get('productId') ?? '';

        // get all payment methods and load a single offer
        combineLatest([this.getOffer(),this.getAllShippingMeans()])
            .subscribe(
                (values: any) => {
                    this.offer = values[0];
                    this.offer.localPickup = this.offer.localPickup === 1;
                    this.shippingMeans = values[1];
                    this.groupShippingMeansByType(values[1]);
                    this.shippingOffers = this.offer.shippingOffers;
                    this.myPaymentMethods = this.offer.paymentMethods;
                    this.mediaList = this.offer.mediaList??[];
                    this.hasPictures = (this.mediaList.length > 0);
                    this.totalOfImages = this.mediaList.length;

                    // Load available shipping options for seller's country
                    this.loadAvailableShippingOptions();
                    // Load currently selected shipping options for this offer
                    this.loadOfferShippingOptions();

                },
                (error: any) => {
                    this.toastrService.error(error);
                },
                () => {
                    this.loading = false;
                    // this.setSelectedPayments();
                }
            );
    }

getOffer() {
        return this.offerService.getOffer(this.user.id, Number(this.offerId));
    }

    getAllShippingMeans() {
        return this.shippingMeanService.getAllShippingMeans();
    }

    chooseFiles(eltId: string) {
        document.getElementById(eltId)?.click();
    }

    onChange(event) {
        this.picture = event.target.files;
        this.hasPictures = true;
        // this.imageChangedEvent = event;
        this.uploadPicture();
    }

    imageCropped(imageCroppedEvent: ImageCroppedEvent) {
        this.imageChangedEvent = null;
        this.imageCroppedEvent = imageCroppedEvent;
        if (imageCroppedEvent.blob) {
            this.croppedImage = imageCroppedEvent.blob;
            this.uploadPicture();
        }
    }

    uploadPicture() {
        const uuid = Utilities.getUUID();
        $('.screenshots #pictures').append('<div class="product-img" id="' + uuid + '"><div class="loader"></div></div>');
        return this.offerService.uploadPicture(this.user.id, Number(this.offerId), this.picture[0])
            .subscribe(
                (media: any) => {
                    $('#' + uuid).remove();
                    this.hasPictures = true;
                    this.totalOfImages++;
                    this.mediaList.push(media);
                },
                (error: any) => {
                    $('#' + uuid).remove();
                    this.toastrService.error(error);
                }
            );
    }

    deleteOfferPicture(media) {
        this.totalOfImages--;
        if (this.totalOfImages === 0) {
            this.hasPictures = false;
        }
        const index = this.mediaList.indexOf(media);
        this.mediaList.splice(index, 1);
        this.mediaService.deleteMedia(media.id).subscribe();
    }

    isSelected(paymentMethod) {
        let found = false;
        for (let i = 0; i < this.myPaymentMethods.length; i++) {
            if (this.myPaymentMethods[i].id === paymentMethod.id) {
                found = true;
                break;
            }
        }
        return found;
    }

    checkOrUncheckPaymentMethod(paymentMethod) {
        const index = this.selectedPaymentMethods.indexOf(paymentMethod);
        (this.selectedPaymentMethods.length === 0 || (index < 0)) ?
            this.selectedPaymentMethods.push(paymentMethod)
            :
            this.selectedPaymentMethods.splice(index, 1);
    }

    saveSelectedPaymentMethods() {
        this.myPaymentMethods = this.selectedPaymentMethods.slice(0, this.selectedPaymentMethods.length);

        const items = [];
        for (let j = 0; j < this.selectedPaymentMethods.length; j++) {
            const paymentMethod = new PaymentMethod();
            paymentMethod.id = this.selectedPaymentMethods[j].id;
            items.push(paymentMethod);
        }

        const subs = this.offerService.savePaymentMethods(this.user.id, Number(this.offerId), items).subscribe(
            () => {
                const subs = this.translateService.get('offers.payment_methods_saved').subscribe(value => {
                    this.toastrService.success(value);
                });
                this.subscriptions.push(subs);
            },
            error => {
                this.toastrService.error(error);
            }
        );

        this.subscriptions.push(subs);
    }

    getImageSrc(imagePath) {
        return imagePath !== '' && imagePath !== null ? environment.apiUrl + '/' + imagePath : '/assets/images/default.jpg';
    }

    // ==================== NEW SHIPPING OPTIONS METHODS ====================

    loadAvailableShippingOptions(): void {
        const userCountryId = typeof this.user.country === 'object' ? this.user.country?.id : this.user.country;
        if (userCountryId) {
            this.shippingMeanService.getAvailableShippingOptions(Number(userCountryId)).subscribe({
                next: (response: any) => {
                    this.availableShippingOptions = response?.data || response || [];
                },
                error: () => {
                    this.availableShippingOptions = [];
                }
            });
        }
    }

    loadOfferShippingOptions(): void {
        this.offerService.getOfferShippingOptions(Number(this.offerId)).subscribe({
            next: (response: any) => {
                const options = response?.data || response || [];
                this.selectedShippingOptions = options.map(o => o.id);
            },
            error: () => {
                this.selectedShippingOptions = [];
            }
        });
    }

    toggleShippingOption(optionId: number, productConditionId: number | null): void {
        const index = this.selectedShippingOptions.indexOf(optionId);
        if (index > -1) {
            this.selectedShippingOptions.splice(index, 1);
        } else {
            this.selectedShippingOptions.push(optionId);
        }
    }

    isShippingOptionSelected(optionId: number): boolean {
        return this.selectedShippingOptions.includes(optionId);
    }

    saveShippingOptions(): void {
        const subs = this.offerService.saveOfferShippingOptions(Number(this.offerId), this.selectedShippingOptions).subscribe({
            next: () => {
                this.translateService.get('offers.shipping_updated').subscribe(value => {
                    this.toastrService.success(value);
                });
            },
            error: () => {
                this.translateService.get('offers.failed_update_shipping').subscribe(value => {
                    this.toastrService.error(value);
                });
            }
        });
        this.subscriptions.push(subs);
    }

    // ==================== MODAL METHODS ====================

    openShippingOptionsModal(): void {
        this.showShippingOptionsModal = true;
        this.modalLoading = true;
        this.modalSelectedOptions = [...this.selectedShippingOptions];
        this.modalShippingPricings = new Map();
        this.modalPricingLoading = new Map();
        const userCountryId = typeof this.user.country === 'object' ? this.user.country?.id : this.user.country;
        if (userCountryId) {
            this.shippingMeanService.getAvailableShippingOptions(Number(userCountryId)).subscribe({
                next: (response: any) => {
                    this.modalShippingOptions = response?.data || response || [];
                    this.modalLoading = false;
                    this.modalSelectedOptions.forEach(id => this.loadPricingForOption(id));
                },
                error: () => {
                    this.modalShippingOptions = [];
                    this.modalLoading = false;
                }
            });
        } else {
            this.modalLoading = false;
        }
    }

    private loadPricingForOption(optionId: number): void {
        const option = this.modalShippingOptions.find(o => o.id === optionId);
        if (!option) {
            return;
        }
        this.modalPricingLoading.set(optionId, true);
        this.shippingMeanService.getShippingPricingAll(optionId, this.offer?.productCondition?.id).subscribe({
            next: (pricingResponse: any) => {
                const pricings = pricingResponse?.data || [];
                this.modalShippingPricings.set(optionId, pricings);
            },
            error: () => {
                this.modalShippingPricings.set(optionId, []);
            },
            complete: () => {
                this.modalPricingLoading.set(optionId, false);
            }
        });
    }

    closeShippingOptionsModal(): void {
        this.showShippingOptionsModal = false;
        this.modalShippingOptions = [];
        this.modalShippingPricings = new Map();
        this.modalPricingLoading = new Map();
        this.modalSelectedOptions = [];
        this.modalLoading = false;
    }

    toggleModalOption(optionId: number): void {
        const index = this.modalSelectedOptions.indexOf(optionId);
        if (index > -1) {
            this.modalSelectedOptions.splice(index, 1);
            this.modalShippingPricings.delete(optionId);
            this.modalPricingLoading.delete(optionId);
        } else {
            this.modalSelectedOptions.push(optionId);
            this.loadPricingForOption(optionId);
        }
    }

    isModalOptionSelected(optionId: number): boolean {
        return this.modalSelectedOptions.includes(optionId);
    }

    isInternationalOption(option: any): boolean {
        return this.matchesShippingType(option, 'INTERNATIONAL');
    }

    isCityBasedOption(option: any): boolean {
        return this.matchesShippingType(option, 'INTERCITY') || this.matchesShippingType(option, 'INTRACITY');
    }

    hasCoverageData(option: any, pricing: any): boolean {
        if (this.isInternationalOption(option)) {
            return !!(pricing?.allCountries || pricing?.countries?.length);
        }
        if (this.isCityBasedOption(option)) {
            return !!(pricing?.allCities || pricing?.cities?.length);
        }
        return !!(pricing?.allCountries || pricing?.allCities || pricing?.countries?.length || pricing?.cities?.length);
    }

    hasModalPricingCoverage(option: any): boolean {
        const pricings = this.modalShippingPricings.get(option?.id) || [];
        return pricings.some((pricing: any) => this.hasCoverageData(option, pricing));
    }

    private matchesShippingType(option: any, type: string): boolean {
        const shippingType = option?.shippingType;
        const code = (shippingType?.code || '').replace(/[^A-Z]/gi, '').toUpperCase();
        if (code) {
            return code === type;
        }
        const description = (shippingType?.description || '').replace(/[^A-Z]/gi, '').toUpperCase();
        return description.includes(type);
    }

    saveModalSelections(): void {
        this.selectedShippingOptions = [...this.modalSelectedOptions];
        this.saveShippingOptions();
        this.closeShippingOptionsModal();
    }

    removeSelectedOption(optionId: number): void {
        const index = this.selectedShippingOptions.indexOf(optionId);
        if (index > -1) {
            this.selectedShippingOptions.splice(index, 1);
            this.saveShippingOptions();
        }
    }

    getOptionName(optionId: number): string {
        const option = this.availableShippingOptions.find(o => o.id === optionId);
        if (option) {
            return `${option.logisticAgent || option.shippingType?.description || ''} - ${option.country?.name || ''}`;
        }
        return '';
    }

    // ==================== OLD SHIPPING OFFER METHODS (COMMENTED OUT) ====================
    /*
    openShippingOfferForm() {
        this.formShippingOpened = !this.formShippingOpened;
        this.shippingOffer = null;
    }

    editShippingOffer(shippingOffer) {
        this.shippingOffer = shippingOffer;
        this.formShippingOpened = !this.formShippingOpened;
    }

    deleteShippingOffer(shippingOffer) {
        const subs = this.translateService.get('offers.confirm_delete').subscribe(value => {
            if (confirm(value)) {
                this.removeCurrentShippingOfferInTheList(shippingOffer);
                this.shippingOfferService.deleteShippingOffer(Number(this.offerId), shippingOffer.id).subscribe(
                    (result: any) => this.toastrService.success(result.message)
                );
            }
        });

        this.subscriptions.push(subs);
    }

    saveShippingOffer(shippingOffer) {
        // clear shipping type
        shippingOffer.shippingMean.shippingType.shippingMeanList = [];
        shippingOffer.id !== '' ? this.updateShippingOffer(shippingOffer) : this.addShippingOffer(shippingOffer);
        this.groupShippingMeansByType(this.shippingMeans);
    }

    closeShippingOfferForm(status) {
        this.formShippingOpened = status;
    }
    */

    private setSelectedPayments() {
        for (let i = 0; i < this.paymentMethods.length; i++) {
            if (this.isSelected(this.paymentMethods[i])) {
                this.selectedPaymentMethods.push(this.paymentMethods[i]);
            }
        }
    }

    private groupShippingMeansByType(shippingMeans) {
        this.shippingTypes = [];
        let shippingType = new ShippingType();
        for (let i = 0; i < shippingMeans.length; i++) {
            if (i === 0 && shippingType.id !== shippingMeans[i].shippingType.id) {
                if (shippingType.id !== undefined && shippingType.id !== shippingMeans[i].shippingType.id) {
                    this.shippingTypes.push(shippingType);
                }
                shippingType = shippingMeans[i].shippingType;
                shippingType.shippingMeanList = [];
            }

            shippingType.shippingMeanList.push(shippingMeans[i]);
        }

        if (shippingType.id !== undefined) {
            this.shippingTypes.push(shippingType);
        }
    }

    private addShippingOffer(shippingOffer) {
        const subs = this.shippingOfferService.addShippingOffer(Number(this.offerId), shippingOffer).subscribe(
            (shippingOfferSaved: any) => {
                this.shippingOffers.push(shippingOfferSaved);
                this.formShippingOpened = false;

                this.translateService.get('offers.order_added').subscribe(value => {
                    this.toastrService.success(value);
                });
            },
            () => {
                this.translateService.get('offers.failed_add_order').subscribe(value => {
                    this.toastrService.error(value);
                });
            }
        );

        this.subscriptions.push(subs);
    }

    private updateShippingOffer(shippingOffer) {
        this.removeCurrentShippingOfferInTheList(shippingOffer);
        const subs = this.shippingOfferService.updateShippingOffer(Number(this.offerId), shippingOffer).subscribe(
            (shippingOfferSaved: any) => {
                this.shippingOffers.push(shippingOfferSaved);
                this.formShippingOpened = false;

                this.translateService.get('offers.shipping_updated').subscribe(value => {
                this.toastrService.success(value);
                });
            },
            () => {
                this.translateService.get('offers.failed_update_shipping').subscribe(value => {
                    this.toastrService.error(value);
                });
            }
        );

        this.subscriptions.push(subs);
    }

    private removeCurrentShippingOfferInTheList(shippingOffer) {
        const index = this.shippingOffers.indexOf(shippingOffer);
        this.shippingOffers.splice(index, 1);
    }


    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
